const messages = require('../../../module/base/language/messages');

module.exports = (string, stringsToReplace) => {
  const lang = (typeof language !== 'undefined') ? language : 'en';

  let message = '';

  if ((string in messages) && (lang in messages[string])) {
    message = messages[string][lang];
  } else {
    message = string;
  }

  return message.formatUnicorn(stringsToReplace);
};
